import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

const IndiceCitoyennete = () => {
  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-32 pb-0 bg-gradient-to-b from-primary/10 to-background">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Et si on prenait un peu plus soin de notre République ?
            </h1>
            <p className="text-xl md:text-2xl text-muted-foreground mb-4">
              « Mesurer » la citoyenneté pour mieux la faire vivre.
            </p>
            <p className="text-lg text-muted-foreground italic">
              Frédéric Sebag, Président de l'association "Enfants de la République"*
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-lg shadow-lg p-8 text-justify">
              <div className="space-y-6 text-lg leading-relaxed">
                <p>
                  Il se trouve des situations, des moments pour lesquels on ne reste pas spectateur. Rien ne prédestinait quelques personnes, acteurs de la vie civile, cadre, employé, essayiste, psychologue ou chef d'entreprise en ce qui me concerne, à éprouver cet impératif de faire quelque chose pour notre vivre ensemble, nos valeurs républicaines.
                </p>
                
                <p>
                  Nous, Enfants de la République, profondément laïques, Virginie, Nathalie, Tiffany, Mehdi, Thierry, Gérard, ou Frédéric, …, simples citoyens et avec nous déjà près d'une centaine d'adhérents issus de tous horizons, professions et origines pensons que notre République et ses valeurs s'inscrivent dans un processus vivant synthétisé dans la Charte des droits et des devoirs du citoyen français (article 21-24 du code civil – JO du 31 janvier 2012). Dès lors, la mission de notre association repose sur trois piliers :
                </p>
                
                <ol className="list-decimal list-inside space-y-3 ml-4">
                  <li>
                    <strong>Transmettre :</strong> Faire redécouvrir aux jeunes générations les valeurs et les réalisations de la République, leur donner les outils pour être à leur tour les artisans et les gardiens de cette Charte.
                  </li>
                  <li>
                    <strong>Renforcer :</strong> Proposer une extension de la Charte des droits et des devoirs du citoyen français ainsi qu'une évolution de sa portée dans afin que chacun, né ou devenu Français, prenne conscience de ce que signifie appartenir à cette nation singulière et s'engage dans son appropriation.
                  </li>
                  <li>
                    <strong>Protéger :</strong> Agir légalement contre ceux qui, par calcul ou par négligence, s'attaquent aux fondements de la République, qu'ils soient élus ou citoyens, institutions ou groupes d'influence.
                  </li>
                </ol>
                
                <p>
                  On parle beaucoup de la République. On la défend, on l'invoque, on la célèbre, parfois on la pleure. Mais qui la mesure ? Qui s'attache, concrètement, à savoir si son état de santé est bon ? Si son socle, notre engagement citoyen envers ses valeurs, ses principes, ses lois, sont solides et partagés ?
                </p>
                
                <p>
                  Pour aborder ces sujets factuellement, sans ressenti, nous avons créé l'Indice de Citoyenneté Française (ICF), miroir de notre relation aux principes républicains, à notre modèle de société qui aspire à la Liberté, à la dignité des individus et à la cohésion sociale dans un état de droit. Pas un sondage. Pas une pétition. Un indice, chiffré, sourcé, public, suivi année après année.
                </p>
                
                <p>
                  L'ICF repose sur 10 indicateurs clés (cf tableau de synthèse), couvrant aussi bien les droits que les devoirs caractéristiques des valeurs, principes et lois contenus dans La Charte des Droits et devoirs du citoyen français. Ces indicateurs sont aussi choisis pour être suffisamment représentatifs de notre société et représentent équitablement les valeurs de Liberté, Egalité, Fraternité, Laïcité. La mesure de ces indicateurs en données brutes s'appuie uniquement sur des sources officielles indiscutables et vérifiables (INSEE, Ministères, organismes publics reconnus) en étant comparables sur 10 ans.
                </p>
                
                <p className="font-medium">
                  C'est un outil de diagnostic, pas de jugement.
                </p>
                
                <p>
                  En 2024, le score global est de 48 sur 100** indiquant d'emblée la tiédeur de notre engagement citoyen mais, surtout, ce que montre l'ICF sur 10 ans est clair : la République avance à deux vitesses. D'un côté, les droits progressent, passant de 36 sur 100 en 2015 à 62 sur 100 en 2024 : on vote librement, la presse regagne en indépendance, l'égalité salariale femmes/hommes s'améliore et l'accès aux aides sociales demeure solide. De l'autre côté, les devoirs s'affaiblissent fortement, passant sur la même période de 64 sur 100 à 34 sur 100 ! Les violences interpersonnelles augmentent. Les atteintes à la laïcité en milieu scolaire se multiplient. Le devoir civique recule.
                </p>
                
                <p className="font-medium">
                  C'est là l'alerte majeure. Une citoyenneté déséquilibrée : des droits obtenus mais des devoirs délaissés.
                </p>
                
                <p>
                  L'ICF n'est pas là pour pointer des fautes. Il est là pour éclairer, alerter, susciter l'action. Ce que nous mesurons, nous pouvons l'améliorer.
                </p>
                
                <p>
                  Cette mesure de notre citoyenneté à partir d'un texte sobre et puissant signé par tout nouveau citoyen lors d'une naturalisation doit permettre d'enclencher un nouvel élan de partage de ce pacte par tous les français permettant de construire ensemble un avenir où nos droits et nos devoirs bénéficient de la même énergie, un avenir respectueux des principes qui nous unissent !
                </p>
                
                <p>
                  Aussi, nous proposons, dans un premier temps, que la Charte soit redécouverte, revalorisée, véritablement enseignée. Qu'elle entre dans les écoles, les administrations, la vie publique car une République qui ne rappelle plus à ses membres ce qu'elle est, est une République qui s'efface ainsi que malheureusement ces chiffres montrent. Dans un deuxième temps, nous devons, ensemble, ouvrir le débat sur l'extension de son champ et de ses modalités d'application tout en protégeant celle-ci de ses contrevenants.
                </p>
                
                <p>
                  Enfants de la République a choisi de relever ce défi, redonner vie à notre citoyenneté afin de la transmettre intacte dans son esprit à nos propres enfants. Si la citoyenneté est une construction commune, alors chacun a sa part de responsabilité dans sa vitalité.
                </p>
                
                <p className="font-medium">
                  Nous sommes une force de proposition pour un projet collectif contre la fragmentation de notre République car elle n'est pas un acquis : elle est une exigence. Une exigence de vérité, de courage et de transmission que, pour notre part, nous vivons comme une chance.
                </p>
                
                <p className="text-sm italic mt-8">
                  * Association de loi 1901 créée en 2025 pour transmettre, renforcer et protéger la Charte des droits et des devoirs du citoyen français (art 21-24 du code civil).
                </p>
                
                <p className="text-sm italic">
                  ** Le rapport complet ICF Enfants de la République est disponible sur ledlr.org
                </p>
              </div>
            </div>
            
            {/* Rapport complet section */}
            <div className="mt-8 bg-secondary rounded-lg p-6 text-white">
              <p className="text-lg text-center">
                Le rapport complet sur l'ICF 2025 Enfants de la République est disponible ici : 
                <a 
                  href="https://jqswmyqzmjdstetjqzvv.supabase.co/storage/v1/object/public/edlr-icf2025/EDLR_ICF2025.pdf" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="ml-2 text-white hover:underline font-medium"
                >
                  ICF 2025
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default IndiceCitoyennete;